import { Typography } from '@/components/ui/typography';
import type { ComponentData } from '@/types/table';

interface ImportHistoryCardProps {
  row: Record<string, unknown>;
}

/**
 * Sub-lg card equivalent of an ImportHistoryTable row (DataTable's
 * renderMobileCard slot). Reuses the row's existing cell components —
 * a card must show every field its table row shows.
 */
export function ImportHistoryCard({ row }: ImportHistoryCardProps) {
  const state = row.state as ComponentData | null;
  const success = row.success as ComponentData | null;
  const failed = row.failed as ComponentData | null;
  const action = row.action as ComponentData | null;

  return (
    <div
      className="rounded-lg border border-border bg-card p-4"
      data-testid="import-history-card"
    >
      <div className="flex items-start gap-2">
        {state?.component}
        <div className="min-w-0 flex-1">
          <Typography as="p" variant="body-semibold" className="break-words">
            {String(row.fileName ?? '')}
          </Typography>
          <Typography as="p" variant="small" className="text-muted-foreground">
            {String(row.uploadedTimestamp ?? '')} · {String(row.uploadedBy ?? '')}
          </Typography>
        </div>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        {success?.component}
        {failed?.component}
      </div>
      {action?.component != null && <div className="mt-1">{action.component}</div>}
    </div>
  );
}
